// ============================================================================
// OBT F3-C — Basit bar grafiği (recharts). Renk TEK BAŞINA anlam taşımaz:
// eksen etiketleri + değerler + erişilebilir tablo özeti daima vardır.
// ============================================================================
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Card, CardContent } from '@/components/ui/card';
import { ObtEmptyState } from '../ObtStates';

const PALETTE = ['#2563eb', '#16a34a', '#d97706', '#dc2626', '#7c3aed', '#0891b2', '#4b5563'];

/**
 * @param {object} props
 * @param {string} props.title
 * @param {Array<{name: string, value: number}>} props.data
 * @param {(v: number) => string} [props.valueFormatter]
 * @param {string} [props.emptyText]
 * @param {number} [props.height]
 */
export default function ReportChart({
  title,
  data,
  valueFormatter = (v) => String(v),
  emptyText = 'Grafik için veri yok.',
  height = 240,
}) {
  const rows = (Array.isArray(data) ? data : []).filter((d) => d && d.name != null);
  const hasValue = rows.some((d) => Number(d.value) > 0);

  return (
    <Card>
      <CardContent className="space-y-2 p-4">
        <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
        {!hasValue ? (
          <ObtEmptyState title={emptyText} />
        ) : (
          <>
            <div style={{ width: '100%', height }} aria-hidden="true">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={rows} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} interval={0} angle={-15} textAnchor="end" height={50} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={36} />
                  <Tooltip formatter={(v) => valueFormatter(Number(v))} />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                    {rows.map((_, i) => (
                      <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            {/* Erişilebilir metin özeti — grafik yalnız görsel değildir. */}
            <ul className="sr-only">
              {rows.map((d) => (
                <li key={d.name}>{`${d.name}: ${valueFormatter(Number(d.value) || 0)}`}</li>
              ))}
            </ul>
          </>
        )}
      </CardContent>
    </Card>
  );
}
